import { getUserFeed, getNextPageUserFeed } from '@/views/profile/components/feed/api'

export default {
    namespaced: true,
    state: {
        loadingFeed: false,
        feed: [],
        pagination: {
            page: 1,
            total: null,
            per_page: 10,
            last_page: null,
            from: null,
            to: null,
            current_page: 1,
        },
    },
    mutations: {
        ADD_FEED(state, { feed }) {
            state.feed = state.feed.concat(feed)
        },
        RESET_FEED(state) {
            state.feed = []
        },
        SET_PAGINATION(state, { pagination }) {
            state.pagination = {
                total: pagination.total,
                per_page: pagination.per_page,
                last_page: pagination.last_page,
                last_page_url: pagination.last_page_url,
                next_page_url: pagination.next_page_url,
                from: pagination.from,
                to: pagination.to,
                current_page: pagination.current_page,
            }
        },
        SET_DEFAULT_PAGINATION(state) {
            state.pagination = {
                total: null,
                per_page: 10,
                last_page: null,
                last_page_url: null,
                next_page_url: null,
                from: null,
                to: null,
                current_page: 1,
            }
        },
        TOGGLE_LOADING_FEED(state) {
            state.loadingFeed = !state.loadingFeed
        },
    },
    actions: {
        async getUserFeed({ dispatch, commit, state }, { userId, periods }) {
            commit('TOGGLE_LOADING_FEED')
            const { data, ...pagination } = await getUserFeed(userId, state.pagination, periods)
            commit('RESET_FEED')
            commit('ADD_FEED', { feed: data })
            commit('SET_PAGINATION', { pagination })
            commit('TOGGLE_LOADING_FEED')
            dispatch('toggleLoading', null, { root: true })
        },
        async getNextPageUserFeed({ commit, state }) {
            commit('TOGGLE_LOADING_FEED')
            const { data, ...pagination } = await getNextPageUserFeed(state.pagination.next_page_url)
            commit('ADD_FEED', { feed: data })
            commit('SET_PAGINATION', { pagination })
            commit('TOGGLE_LOADING_FEED')
        },
        resetFeed({ commit }) {
            commit('RESET_FEED')
        },
        setDefaultPagination({ commit }) {
            commit('SET_DEFAULT_PAGINATION')
        },
    },
    getters: {},
}
